/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";
import { ITecnologiasRepository } from "@/interface/tecnologias";

const tecnologiasRepository: ITecnologiasRepository = {
  /**
   * Função para buscar tecnologias
   * @param accessToken
   * @returns Promise<any | null>
   */
  async getAllTecnologias<T>(
    accessToken: string,
    currentPage: number = 1,
    itemsPerPage: number = 10,
    searchItem = "",
    somenteAtivos = false
  ): Promise<T | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const ativoParam = somenteAtivos ? "&ativo=1" : "";
    const tecnologias = await Instance.get(
      `/tecnologias?page=${currentPage}&per_page=${itemsPerPage}&search=${searchItem}${ativoParam}`,
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
          accept: "*/*",
        },
      }
    );

    return tecnologias?.data;
  },
};

/**
 * EXPORTS
 */
export { tecnologiasRepository };
